import styled from '@emotion/styled';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_REGULAR } from '../../constant/spacing';
import { flexibleLayoutContainer, flexibleLayoutItem } from '../../styleUtility/flexibleLayout';
import { gridLayoutContainer, gridLayoutItem } from '../../styleUtility/gridLayout';
import DummyContent from '../primitive/DummyContent';

interface Props {
  creationSetSize?: number;
  creationFormatSize?: number;
  className?: string;
}

const DummyCreationSetList = ({
  creationSetSize = 1,
  creationFormatSize = 2,
  className,
}: ClassAttributes<HTMLElement> & Props) => {
  const dummyCreationSet = new Array(creationSetSize).fill(null).map((_, i) => i);
  const dummyCreativeFormats = new Array(creationFormatSize).fill(null).map((_, i) => i);

  const creationSetDetail = (index: number) => {
    return (
      <Table key={`creation_set_table_${index}}`} className={className}>
        <TableHead>
          <TableRow>
            <TableCell padding="default">
              <ColumnName variant="caption" color="textSecondary" noWrap>
                <FormattedMessage id="creation_set_list.creation_set_list_item.detail.column_name.network" />
              </ColumnName>
            </TableCell>
            <TableCell padding="default">
              <ColumnName variant="caption" color="textSecondary" noWrap>
                <FormattedMessage id="creation_set_list.creation_set_list_item.detail.column_name.placement" />
              </ColumnName>
            </TableCell>
            <TableCell padding="default">
              <ColumnName variant="caption" color="textSecondary" noWrap>
                <FormattedMessage id="creation_set_list.creation_set_list_item.detail.column_name.creative_type" />
              </ColumnName>
            </TableCell>
            <TableCell padding="default">
              <ColumnName variant="caption" color="textSecondary" noWrap>
                <FormattedMessage id="creation_set_list.creation_set_list_item.detail.column_name.size" />
              </ColumnName>
            </TableCell>
            <TableCell padding="default">
              <ColumnName variant="caption" color="textSecondary" noWrap>
                <FormattedMessage id="creation_set_list.creation_set_list_item.detail.column_name.length" />
              </ColumnName>
            </TableCell>
            <TableCell padding="default">
              <ColumnName variant="caption" color="textSecondary" noWrap>
                <FormattedMessage id="creation_set_list.creation_set_list_item.detail.column_name.amount" />
              </ColumnName>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {dummyCreativeFormats.map((i) => {
            const dummyCell = (
              <TableCell>
                <DummyContent />
              </TableCell>
            );
            return (
              <TableRow key={`dummy_creation_set_table_row_${i}`}>
                {dummyCell}
                {dummyCell}
                {dummyCell}
                {dummyCell}
                {dummyCell}
                {dummyCell}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  };

  return (
    <Root>
      {dummyCreationSet.map((i) => (
        <CreationSetSection key={`dummy_creation_set_section_${i}}`}>
          <CreationSetSectionHeading>
            <DummyCreationSetSectionTitle />
          </CreationSetSectionHeading>
          <CreationSetSectionBody>
            <CreationSetDetail>{creationSetDetail(i)}</CreationSetDetail>
          </CreationSetSectionBody>
        </CreationSetSection>
      ))}
    </Root>
  );
};

const Root = styled('div')({
  ...flexibleLayoutContainer({
    direction: 'column',
  }),
});

const CreationSetSection = styled('div')({
  ...flexibleLayoutItem({}),
  ...gridLayoutContainer({
    columns: ['auto'],
    rows: ['auto', 'auto'],
    areas: [['sectionHeading'], ['sectionBody']],
  }),
  marginBottom: `${SPACING_REGULAR}px`,
});

const CreationSetSectionHeading = styled('div')({
  ...gridLayoutItem('sectionHeading'),
  ...gridLayoutContainer({
    columns: ['auto'],
    rows: ['auto'],
    areas: [['title']],
  }),
});
const CreationSetSectionBody = styled('div')({
  ...gridLayoutItem('sectionBody'),
  ...gridLayoutContainer({
    columns: [`1fr`],
    rows: ['auto'],
    areas: [['detail']],
  }),
});
const DummyCreationSetSectionTitle = styled(DummyContent)({
  ...gridLayoutItem('title'),
});
const CreationSetDetail = styled('div')(gridLayoutItem('detail'));

const ColumnName = styled(Typography)({});

export default DummyCreationSetList;
